import "./SessionCards.css";

const cardsData = [
  {
    id: "card1",
    icon: "/images/home/cards/icons/icon1.webp",
    title: "Học Viên",
    image: "/images/home/cards/card1.webp",
    description:
      "Cập nhật nhanh chóng những thông tin về lịch học, lịch thi, cẩm nang dành cho học viên Design24.",
  },
  {
    id: "card2",
    icon: "/images/home/cards/icons/icon2.webp",
    title: "Món ngon",
    image: "/images/home/cards/card2.webp",
    description:
      "Khám phá các công thức chế biến món ăn đơn giản, nhanh chóng, nhiều bí quyết từ chuyên gia.",
  },
  {
    id: "card3",
    icon: "/images/home/cards/icons/icon3.webp",
    title: "Tin tức",
    image: "/images/home/cards/card3.webp",
    description:
      "Tìm hiểu các hoạt động của Design24 cùng những thông tin về văn hóa ẩm thực bốn phương.",
  },
  {
    id: "card4",
    icon: "/images/home/cards/icons/icon4.webp",
    title: "Chia sẻ",
    image: "/images/home/cards/card4.webp",
    description:
      "Lắng nghe chia sẻ về xu hướng và những điều cần biết trong từng ngành nghề đào tạo tại Design24.",
  },
];

const SessionCards = () => (
  <section className="session-cards">
    <div className="session-cards__container">
      {cardsData.map(({ id, icon, title, image, description }) => (
        <div
          key={id}
          className="session-cards__card"
        >
          <div className="session-cards__card-icon-wrapper">
            <img
              src={icon}
              alt={`${title} icon`}
              className="session-cards__card-icon"
            />
          </div>

          <h3 className="session-cards__card-title">{title}</h3>

          <img
            src={image}
            alt={title}
            className="session-cards__card-image"
          />

          <p className="session-cards__card-description">{description}</p>
        </div>
      ))}
    </div>
  </section>
);

export default SessionCards;
